<template>
  <div class="platform-data-statistics-index">
    <div class="header-wrapper">
      <div class="data-item">
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          :content="String(schoolCount)"
        >
          <span class="data-count">
            {{schoolCount | toThousandslsFilter}}
          </span>
        </el-tooltip>
        <span class="data-title">服务学校</span>
      </div>
      <div class="data-item">
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          :content="String(schoolActiveCount)"
        >
          <span class="data-count">{{schoolActiveCount | toThousandslsFilter}}</span>
        </el-tooltip>
        <span class="data-title">活跃学校</span>
      </div>
      <div class="data-item">
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          :content="String(userCount)"
        >
          <span class="data-count">{{userCount | toThousandslsFilter}}</span>
        </el-tooltip>
        <span class="data-title">用户总数</span>
      </div>
      <div class="data-item">
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          :content="String(attendUserCount)"
        >
          <span class="data-count">{{attendUserCount | toThousandslsFilter}}</span>
        </el-tooltip>
        <span class="data-title">已关注用户</span>
      </div>
      <div class="data-item">
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          :content="String(activeUserCount)"
        >
          <span class="data-count">{{activeUserCount | toThousandslsFilter}}</span>
        </el-tooltip>
        <span class="data-title">活跃用户数</span>
      </div>
    </div>
    <div class="ping-tai-fang-wen-liang">
      <div class="small-title">平台访问量曲线</div>
      <el-row style="padding-bottom:10px">
        <el-col :span="19">
          时间：
          <el-radio-group
            class="daysBtn"
            size="medium"
            v-model="userLoginCountRadio"
            @change="handleUserLoginCountRadioChange"
          >
            <el-radio-button label="7">7天</el-radio-button>
            <el-radio-button label="14">14天</el-radio-button>
            <el-radio-button label="30">30天</el-radio-button>
          </el-radio-group>
          &nbsp;
          <el-date-picker
            size="medium"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            v-model="dataRange1"
            :clearable="false"
            @change="handleUserLoginCountDateRange"
          ></el-date-picker>
        </el-col>
      </el-row>
      <div
        class="chart"
        id="userLoginCountChart"
      ></div>
    </div>
    <div class="yong-hu-zeng-liang-wrapper">
      <div class="small-title">用户增量统计</div>
      <el-row style="padding-bottom:10px">
        <el-col :span="19">
          时间：
          <el-radio-group
            class="daysBtn"
            size="medium"
            v-model="addUsersRadio"
            @change="handleAddUsersRadio"
          >
            <el-radio-button label="7">7天</el-radio-button>
            <el-radio-button label="14">14天</el-radio-button>
            <el-radio-button label="30">30天</el-radio-button>
          </el-radio-group>
          &nbsp;
          <el-date-picker
            size="medium"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            v-model="dataRange2"
            :clearable="false"
            @change="handleAddUsersDateRange"
          ></el-date-picker>
        </el-col>
      </el-row>
      <div
        class="chart"
        id="activeUserCountChart"
      ></div>
    </div>
  </div>
</template>

<script>
/* utils */
import mixin from "@/mixins/windowResize";

/* components */
import echarts from "echarts";

/* api */
import {
  queryStatistic,
  getAddUsers,
  getUserLoginCount,
} from "@/api/platformDataStatistics";

/* eachart options */
let colorList = [
  "#63b2ee",
  "#76da91",
  "#f8cb7f",
  "#f89588",
  "#7cd6cf",
  "#cb9bff",
  "#7898e1",
  "#efa666",
  "#eddd86",
  "#9987ce",
];
let lineOption = ({ title, legend, xAxis, series }) => ({
  title: Object.assign(
    {
      x: "center",
    },
    title
  ),
  tooltip: {
    trigger: "axis",
  },
  grid: {
    height: "200",
  },
  xAxis: Object.assign(
    {
      show: true,
      position: "bottom",
      type: "category",
      axisTick: {
        alignWithLabel: true,
        show: true,
      },
      axisLine: {
        onZero: true,
        lineStyle: {
          color: "#a3a3a3",
        },
      },
    },
    xAxis
  ),
  yAxis: [
    {
      type: "value",
      axisLabel: {
        formatter: "{value}",
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "#a3a3a3",
        },
      },
    },
  ],
  legend: Object.assign(
    {
      top: "300",
      left: "5%",
      textStyle: {
        color: "#a3a3a3",
      },
      itemWidth: 20,
      itemHeight: 10,
      orient: "horizontal",
    },
    legend
  ),
  series,
});

export default {
  components: {},
  filters: {
    toThousandslsFilter(num) {
      return (+num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
  },
  data() {
    return {
      schoolCount: "",
      schoolActiveCount: "",
      userCount: "",
      attendUserCount: "",
      activeUserCount: "",

      userLoginCountRadio: "7",
      addUsersRadio: "7",
      dataRange1: [],
      dataRange2: [],
      echart: {
        userLoginCountChart: null,
        activeUserCountChart: null,
      },
    };
  },
  created() {
    this.queryStatistic();
    this.getUserLoginCount({
      days: this.userLoginCountRadio,
    });
    this.getAddUsers({
      days: this.addUsersRadio,
    });
  },
  methods: {
    queryStatistic() {
      queryStatistic().then((data) => {
        this.schoolCount = data.schoolCount;
        this.schoolActiveCount = data.schoolActiveCount;
        this.userCount = data.userCount;
        this.attendUserCount = data.attendUserCount;
        this.activeUserCount = data.activeUserCount;
      });
    },
    getUserLoginCount({ days = 0, startDate = "", endDate = "" }) {
      getUserLoginCount({
        days: 0 - days,
        startDate,
        endDate,
      }).then((data) => {
        this.drawUserLoginCountChart([...data]);
      });
    },
    getAddUsers({ days = 0, startDate = "", endDate = "" }) {
      getAddUsers({
        days: 0 - days,
        startDate,
        endDate,
      }).then((data) => {
        this.drawActiveUserCountChart([...data]);
      });
    },
    handleUserLoginCountRadioChange(val) {
      this.dataRange1 = [];
      this.getUserLoginCount({
        days: val,
      });
    },
    handleAddUsersRadio(val) {
      this.dataRange2 = [];
      this.getAddUsers({
        days: val,
      });
    },
    handleUserLoginCountDateRange() {
      this.userLoginCountRadio = "";
      this.getUserLoginCount({
        startDate: this.dataRange1[0],
        endDate: this.dataRange1[1],
      });
    },
    handleAddUsersDateRange() {
      this.addUsersRadio = "";
      this.getAddUsers({
        startDate: this.dataRange2[0],
        endDate: this.dataRange2[1],
      });
    },

    // 时段统计报表 - 折线图
    drawUserLoginCountChart(array) {
      this.echart.userLoginCountChart = echarts.init(
        document.getElementById("userLoginCountChart")
      );
      let loginMobileTotal = array.map((item) => ({
        label: "移动端登陆的总次数",
        value: item.loginMobileTotal,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let loginMobileUsersTotal = array.map((item) => ({
        label: "移动端登陆的总用户数",
        value: item.loginMobileUsersTotal,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let loginPCTotal = array.map((item) => ({
        label: "PC端登陆的总次数",
        value: item.loginPCTotal,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let loginPCUsersTotal = array.map((item) => ({
        label: "PC端登陆的总用户数",
        value: item.loginPCUsersTotal,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let loginTotal = array.map((item) => ({
        label: "每天登陆的总次数",
        value: item.loginTotal,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let loginUsersTotal = array.map((item) => ({
        label: "每天登陆的总用户数",
        value: item.loginUsersTotal,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let _array = [
        loginMobileTotal,
        loginMobileUsersTotal,
        loginPCTotal,
        loginPCUsersTotal,
        loginTotal,
        loginUsersTotal,
      ];
      console.log(_array);
      this.echart.userLoginCountChart.setOption(
        lineOption({
          title: {
            text: "用户登录统计",
          },
          legend: {
            data: [
              "移动端登陆的总次数",
              "移动端登陆的总用户数",
              "PC端登陆的总次数",
              "PC端登陆的总用户数",
              "每天登陆的总次数",
              "每天登陆的总用户数",
            ],
          },
          xAxis: {
            data: _array[0].map((item) => {
              return item.createTime;
            }),
          },
          series: _array.map((item, idx) => {
            console.log(item);
            return {
              name: item[0].label,
              type: "line",
              data: item.map((subItem) => subItem.value),
              itemStyle: {
                normal: {
                  color: colorList[idx] || colorList[0],
                },
              },
            };
          }),
        })
      );
    },

    // 用户增量统计 - 折线图
    drawActiveUserCountChart(array) {
      this.echart.activeUserCountChart = echarts.init(
        document.getElementById("activeUserCountChart")
      );
      let addUsers = array.map((item) => ({
        label: "新增用户",
        value: item.addUsers,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let attendUsers = array.map((item) => ({
        label: "关注用户",
        value: item.attendUsers,
        createTime: item.createTime,
        schoolId: item.schoolId,
      }));
      let _array = [addUsers, attendUsers];
      console.log(_array);
      this.echart.activeUserCountChart.setOption(
        lineOption({
          title: {
            text: "用户每天增量统计",
          },
          legend: {
            data: ["新增用户", "关注用户"],
          },
          xAxis: {
            data: _array[0].map((item) => {
              return item.createTime;
            }),
          },
          series: _array.map((item, idx) => {
            console.log(item);
            return {
              name: item[0].label,
              type: "line",
              data: item.map((subItem) => subItem.value),
              itemStyle: {
                normal: {
                  color: colorList[idx] || colorList[0],
                },
              },
            };
          }),
        })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-data-statistics-index {
  padding: 12px;
  * {
    box-sizing: border-box;
  }
  .header-wrapper {
    background: rgb(242, 242, 242);
    display: flex;
    height: 148px;
    line-height: 44px;
    text-align: center;
    font-size: 0;
    .data-item {
      padding: 30px;
      flex: 0 0 20%;
      width: 20%;
      display: flex;
      flex-direction: column;
      span {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.data-count {
          font-size: 32px;
          font-weight: bold;
          color: #303133;
          cursor: pointer;
        }
        &.data-title {
          font-size: 14px;
          color: #606266;
        }
      }
    }
  }

  .small-title {
    height: 20px;
    line-height: 20px;
    margin: 10px 0;
    padding-left: 8px;
    border-left: 4px solid #409eff;
    color: #333;
  }

  .chart {
    background-color: #fff;
    width: 100%;
    height: 400px;
    padding: 30px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/platformDataStatistics/index.vue